import RefDataCrudPage from './RefDataCrudPage'
import { militaryStatusesApi } from '../api/lookupApi'

export default function MilitaryStatusPage() {
  return <RefDataCrudPage api={militaryStatusesApi} i18nPrefix="optionDefs.militaryStatuses" />
}
